"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decoder = void 0;
const CborDecoder_1 = require("@jsonjoy.com/json-pack/lib/cbor/CborDecoder");
const CrdtReader_1 = require("../../../util/binary/CrdtReader");
const BatchColumnDecoder_1 = require("../BatchColumnDecoder");
/**
 * JSON CRDT Batch "binary" codec decoder.
 */
class Decoder extends CborDecoder_1.CborDecoder {
    /**
     * Creates a new JSON CRDT batch decoder.
     *
     * @param reader An optional custom implementation of a CRDT decoder.
     */
    constructor(reader = new CrdtReader_1.CrdtReader()) {
        super(reader);
    }
    /**
     * Decodes a JSON CRDT batch from a binary blob.
     *
     * @param data Binary data to decode.
     * @returns A JSON CRDT `Batch`.
     */
    decodeBatch(data) {
        this.reader.reset(data);
        return this.readBatch();
    }
    readBatch() {
        const reader = this.reader;
        const minSeq = reader.vu57();
        const maxSeq = reader.vu57();
        const sidTable = this.readUintCol();
        const uint = this.readUintCol();
        const s_old = this.readUintCol();
        const s_new = this.readUintCol();
        const t_obj = this.readUintCol();
        const t_id = this.readUintCol();
        const t_val = this.readUintCol();
        const data = this.readCborCol();
        const meta = this.readCborCol();
        const columns = new BatchColumnDecoder_1.BatchColumnDecoder(minSeq, maxSeq, sidTable, uint, s_old, s_new, t_obj, t_id, t_val, data, meta);
        return columns.decode();
    }
    readUintCol() {
        const reader = this.reader;
        const length = reader.vu57();
        const uint = [];
        for (let i = 0; i < length; i++)
            uint.push(reader.vu57());
        return uint;
    }
    readCborCol() {
        const length = this.reader.vu57();
        const data = [];
        for (let i = 0; i < length; i++)
            data.push(this.readAny());
        return data;
    }
}
exports.Decoder = Decoder;
